export default __webpack_public_path__ + "screens_sm.0c53ddc2.png";